import React, { FC } from "react";
import Highcharts from "highcharts";
import HighchartsTreemap from "highcharts/modules/treemap";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { IResultResponse } from "../../models/response/result.model";
import { IInstrument } from "../../models/instrument.model";
import CommonService from "../../services/common.service";
import HighChartsService from "../../services/highcharts.service";

HighchartsTreemap(Highcharts);

const HeatMap: FC = () => {
  const indexId = useTypedSelector(({ ci }) => ci.indexId);

  const { fetchedData, loading } = useHttpGet<IResultResponse<IInstrument[]>>(
    `${APIRoutes.INSTRUMENT_FOR_INDEX}/${indexId}`,
    {
      dependencies: [indexId],
      condition: !!indexId,
      defaultValue: { result: [] as IInstrument[] },
    }
  );

  const getColor = (value: number, index: number) => {
    return CommonService.LightenDarkenColor(
      value < 0 ? "#ce3e3e" : "#c3ff8f",
      index === 0
        ? 0
        : value < 0
        ? index * 5
        : (fetchedData.result?.length - 1 - index) * 5
    );
  };

  const getOptions = (data: any[]) => {
    return {
      ...HighChartsService.baseSettings({
        tooltip: {
          shared: true,
          formatter() {
            const th: any = this;
            return `${th?.key}<br /> $${CommonService.toLocalNum(
              th?.point?.value
            )} `;
          },
        },
        series: [
          {
            type: "treemap",
            layoutAlgorithm: "squarified",
            data: data
              ?.sort(
                (a: IInstrument, b: IInstrument) =>
                  a?.lastHistoricalData?.changePercent -
                  b?.lastHistoricalData?.changePercent
              )
              ?.map((el: IInstrument, index: number) => {
                return {
                  name: `${el?.name}<br /> ${
                    el?.lastHistoricalData?.changePercent || 0
                  }%`,
                  value: el?.lastHistoricalData?.marketCap,
                  color: getColor(el?.lastHistoricalData?.changePercent, index),
                };
              }),
          },
        ],
      }),
    };
  };

  return (
    <Spin spinning={loading}>
      <HighchartsReact
        highcharts={Highcharts}
        options={getOptions(fetchedData?.result || [])}
      />
    </Spin>
  );
};

export default HeatMap;
